import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import './EmailVerificationBanner.css';

function EmailVerificationBanner({ user, onDismiss }) {
  const [resending, setResending] = useState(false);
  const [message, setMessage] = useState('');

  const handleResendEmail = async () => {
    setResending(true);
    setMessage('');

    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth/resend-verification`,
        { email: user.email },
        { withCredentials: true }
      );

      setMessage(response.data.message || 'Verification email sent! Please check your inbox.');
    } catch (err) {
      console.error('Failed to resend verification email:', err);
      setMessage(
        err.response?.data?.error ||
          'Failed to send verification email. Please try again later.'
      );
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="email-verification-banner">
      <div className="banner-content">
        <div className="banner-icon">⚠️</div>
        <div className="banner-text">
          <strong>Please verify your email address</strong>
          <p>
            We've sent a verification link to <strong>{user.email}</strong>. Your
            account will be automatically deleted if not verified within 7 days.
          </p>
          {message && <p className="banner-message">{message}</p>}
        </div>
        <div className="banner-actions">
          <button
            onClick={handleResendEmail}
            disabled={resending}
            className="btn-resend"
          >
            {resending ? 'Sending...' : 'Resend Email'}
          </button>
          {onDismiss && (
            <button onClick={onDismiss} className="btn-dismiss" aria-label="Dismiss">
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default EmailVerificationBanner;
